import { MoreVert } from '@mui/icons-material';
import {
  Box,
  Chip,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography
} from '@mui/material';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { IBudget } from '../../../common/entities';

export interface IBudgetListItem {
  budget: IBudget;
  onMenuClick: (
    event: React.MouseEvent<HTMLButtonElement>,
    expenseId: string
  ) => void;
}

const BudgetListItemChip = ({ label }: { label: string }) => {
  return (
    <Chip
      sx={{ mr: 1, height: '1.2rem', fontSize: '0.5rem', fontWeight: 600 }}
      label={label}
      color="primary"
      size="small"
      variant="outlined"
    />
  );
};

export const BudgetListItem: FC<IBudgetListItem> = ({
  budget,
  onMenuClick
}: IBudgetListItem) => {
  const itemContent = (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Typography sx={{ marginRight: '10px' }}>{budget.name}</Typography>
      {!budget.accumulation && !budget.single && (
        <BudgetListItemChip label="Monthly" />
      )}
      {!budget.accumulation && budget.single && (
        <BudgetListItemChip label="Single" />
      )}
      {budget.accumulation && budget.closed && (
        <BudgetListItemChip label="Closed" />
      )}
      {/* {budget.accumulation ? (
        <BudgetListItemChip label="Accumulation" />
      ) : (
        <BudgetListItemChip label="Budget" />
      )} */}
    </Box>
  );

  return (
    <ListItem
      sx={{
        width: '100%',
        p: 0,
        borderBottom: '1px solid #f0f0f0'
      }}
      secondaryAction={
        <IconButton
          aria-label="settings"
          onClick={e => onMenuClick(e, budget.id)}
        >
          <MoreVert />
        </IconButton>
      }
    >
      <ListItemButton sx={{ px: 1 }}>
        <ListItemText>
          <Link
            to={{
              pathname: budget.accumulation
                ? `/accumulation/${budget.id}`
                : `/budget/${budget.id}`,
              state: { goBackTitle: 'Back to budgets' }
            }}
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            {itemContent}
          </Link>
        </ListItemText>
      </ListItemButton>
    </ListItem>
  );
};
